<template>
    <div>
        <button type="button" class="btn btn-circle btn-sm btn-outline-dark btn-icon "
                @click="openModal(row)">
            <span class="fa fa-eye"></span>

        </button>
        <div>
            <div id="description_modal" class="modal fade rtl" role="dialog">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div id="title">
                            </div>
                            <button type="button" class="close float-right mr-0" data-dismiss="modal">&times;</button>
                        </div>
                        <div id="data_sheet" class="modal-body mb-4">
                            <table class="table table-hover">
                                <thead id="table-header">
                                <tr>
                                    <th class="table-info" colspan="2">{{
                                        $t('customers_club.event_details')
                                        }}
                                    </th>
                                </tr>
                                </thead>
                                <tbody id="event_detail">
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Vue from "vue";
import {i18n} from '@/plugins/i18n'
import $ from 'jquery';

export default Vue.extend({
    name: "Description",
    methods: {
       async openModal() {
            $('#description_modal').modal('show')
            let event_detail = $('#event_detail').empty()

            let element = '';

            if (this.row.date) {
                element += this.simpleText(this.row.date, i18n.t('label.date'))
            }

            if (this.row.description) {
                element += this.simpleText(this.row.description, i18n.t('label.description'))
            }

            if (this.row.referenceId) {
                element += this.simpleText(this.row.referenceId, i18n.t('label.transaction_ref_id'))
            }

            if (this.row.TransDesc) {
                element += this.simpleText(this.row.TransDesc, i18n.t('label.description'))
            }

            if (this.row.DocTypeFinalDesc) {
                element += this.simpleText(this.row.DocTypeFinalDesc, i18n.t('label.description'))
            }

            event_detail.append(element)
        },
        simpleText(data, title) {
            return '<tr><td style="width: 155px;">' + title + '</td>' +
                '<td>' + data + '</td></tr>'
        }
    },
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    data() {
        return {
            data: {},
        }
    },
})
</script>

<style scoped>

</style>